import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";

export function getOnlineVisibleStores(): string[] {
    if (typeof CountryUtil.getOnlineVisibleStores === "function") {
        return CountryUtil.getOnlineVisibleStores();
    }
    // fallback for when the function in UIDispatcher doesn't exist yet -- FIXME(FD) remove soon
    const storeActivation = (window as any).storeactivation as {
        [s: string]: { storeid: string; onlinevisibility: string; country: string };
    };
    return Object.values(storeActivation)
        .filter((s) => s.onlinevisibility === "ACTIVE" && s.country === CountryUtil.getCountry())
        .map((s) => s.storeid);
}
